import {
  Body2,
  Card,
  Subtitle1,
  makeStyles,
  mergeClasses,
  tokens,
} from '@fluentui/react-components';
import { ReactNode } from 'react';
import './groovCard.css';
import { useIsMobile } from '@hooks/useIsMobile';
import { useThemeContext } from '@theme/ThemeContext';

type Props = {
  title?: string;
  description?: string | ReactNode;
  children?: ReactNode | ReactNode[];
  width?: string;
};

const useStyles = makeStyles({
  cardWrapper: {
    paddingTop: tokens.spacingVerticalXXL,
    paddingBottom: tokens.spacingVerticalXXL,
    paddingLeft: tokens.spacingHorizontalL,
    paddingRight: tokens.spacingHorizontalL,
    width: '100%',
  },
  descriptionWrapper: {
    marginRight: tokens.spacingHorizontalXXL,
    '@media screen and (min-width: 768px)': { maxWidth: '66%' },
  },
  bodyWrapper: {
    rowGap: tokens.spacingVerticalXXL,
  },
});

export const GroovBaseCard = (props: Omit<Props, 'title' | 'description'>) => {
  const { theme } = useThemeContext();
  const isMobile = useIsMobile();

  const horizontalPadding = isMobile ? theme?.spacingHorizontalL : theme?.spacingHorizontalXL;
  const verticalPadding = isMobile ? theme?.spacingVerticalXXL : theme?.spacingVerticalXL;

  return (
    <Card
      style={{
        paddingRight: horizontalPadding,
        paddingLeft: horizontalPadding,
        paddingTop: verticalPadding,
        paddingBottom: verticalPadding,
        borderRadius: theme?.borderRadiusXLarge,
        width: props.width,
      }}
    >
      {props.children}
    </Card>
  );
};

export const GroovCard = (props: Props) => {
  const { theme } = useThemeContext();
  const styles = useStyles();

  return (
    <GroovBaseCard width={props.width}>
      {props.title && (
        <Subtitle1 style={{ marginBottom: theme?.spacingVerticalS }}>{props.title}</Subtitle1>
      )}
      <div className={mergeClasses(styles.bodyWrapper, 'bodyWrapper')}>
        {props.description && (
          <Body2 className={styles.descriptionWrapper}> {props.description}</Body2>
        )}
        {props.children}
      </div>
    </GroovBaseCard>
  );
};

export const GroovControlCard = (props: Omit<Props, 'title' | 'description'>) => {
  const { theme } = useThemeContext();

  const horizontalPadding = theme?.spacingHorizontalL;
  const verticalPadding = theme?.spacingVerticalXS;

  return (
    <Card
      style={{
        paddingRight: horizontalPadding,
        paddingLeft: horizontalPadding,
        paddingTop: verticalPadding,
        paddingBottom: verticalPadding,
        borderRadius: theme?.borderRadiusXLarge,
        width: props.width ?? 'fit-content',
      }}
    >
      {props.children}
    </Card>
  );
};
